<template>
    <a
        v-if="link"
        :class="modifiers"
        :href="link"
        download
        target="_blank"
        rel="noopener noreferrer"
    >
        <icon v-if="icon" :icon="icon"></icon>
        {{ label }}
    </a>
</template>

<script>
import Icon from "./AtomIcon.vue";

export default {
    props: {
        modifiers: String,
        label: String,
        icon: String,
        link: String,
        disabled: Boolean
    },
    components: {
        Icon
    },
    computed: {
        classes: function() {
            let classes = "";
            classes += `${this.modifiers} `;
            classes += this.icon ? "c-a-button--with-icon " : "";
            classes += this.disabled ? "c-a-button--disabled " : "";
            return classes;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomFileDownload.vue